module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "CHAPTER 1 Introduction TO BEER",
      "src": "images/f0014-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pull_quote"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" What is it about brewing beer? Holding this book in your hand, you are as much as admitting that there is some special fascination with it, but what?")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Is it about creating a beer for its practical qualities as a thirst-quenching and refreshing beverage, or perhaps for its suppleness as a dining companion (one that doesn’t dominate or dismiss its partners), or as a tasty and temperate path to relaxation if not abused?")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Is it beer’s willingness to bend to the needs and moods of the seasons, offering a meaningful way to engage in the flow of time—as sustenance and succor in a dark, cold winter, as hearty harbinger of spring, as celebration of the mindless joy of summer, or as autumn’s rich and toasty counterpoint to the harvest’s bounty? Beer suits the moment like no other drink.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Maybe it’s that every glass portends a vast range of possibilities. Dozens of ingredients creating unlimited possibilities in terms of strength, color, and flavor, topped off by a universe of amazing aromas. It’s easy to be drawn in by the sense of endless creativity as each new brew offers its delicious rewards.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Perhaps it’s beer’s ability to draw people into an easy camaraderie. Every brewery, no matter how small, starts to build a community around it. It is a highly social hobby because the product creates sociability—inescapably so. I promise that brewing will draw people to you.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Maybe it’s the empowerment you feel as a maker of beer to provoke, entertain, surprise, seduce, and satisfy people. To brew well certainly invites a heaping plateful of rewards, but brewing great beer is not a simple pursuit. Creating art at a high level never is. Learning to master brewing means understanding the many biochemical, sensory, and practical aspects of beer, brewing, and tasting. Like any pursuit, brewing’s returns are proportionate to what you put into it. The good news is that you can make really tasty beer right from the beginning. Then, you’ll have plenty to sustain you as you improve your skills.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0015-01.jpg"
    }
  })])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev1"
    }
  }), _vm._v("QUICK START GUIDE")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("I love to hear the sound of my words rattling around in your head as much as the next author, but I’d like to suggest you jump ahead and get a brew going. Hands-on learning is the best; everything makes so much more sense when you can see it, taste it, touch it. If you’re not yet brewing, I urge you to do so at the earliest possible opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Purchase the items listed on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#page_118"
    }
  }, [_vm._v("page 118")]), _vm._v(". If you’re really in a hurry, go to your nearest homebrew store and buy an equipment kit. Just be sure to get a 6.5-gallon/25-L carboy, as these don’t always come with the kits and I think they make better beer and less mess. You will also need a stainless-steel pot of 4- to 5-gallon/14- to 19-L capacity, and a stove or burner capable of heating it to boiling. And start saving bottles (non-twist-off preferred) to fill with your beer when the time comes "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev22"
    }
  }, [_vm._v("(see the Bottling Gear, page 187)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Pick out a recipe, use The Amazing Shape-Shifting Beer Recipe on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev1"
    }
  }, [_vm._v("page 116")]), _vm._v(", or, if you’re in a hurry, get a kit. Just make sure it’s not pure extract and if there is sugar in it, that there’s just a little. Also shoot for something in the normal alcohol range (4.5 to 6 percent). Higher-alcohol beers are more challenging to brew and take longer to mature into a drinkable state.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Don’t forget the yeast. There’s nothing really wrong with dry yeast, but if you’re serious, go for the liquid, which offers genuine brewing pedigrees and a lot more strains to choose from. Pick an ale yeast appropriate for the style you’re brewing, or just go crazy and pick a yeast strain that sounds interesting to you. When in doubt, use Chico, a.k.a. California Ale. Forget about lager for now.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("BASIC KIT OF HOMEBREW GEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("A typical beginner’s brewing kit will include the following (clockwise from top right): carboy for conditioning, racking hose (in this example with a siphon starter as part of it), stirring paddle or spoon, hydrometer, thermometer, bottling wand, fermentation lock, bottle and carboy brushes for cleaning, a bottle capper, a stick-on thermometer for the carboy, a plastic fermenter, and a bottling bucket with a spigot. A stainless-steel brewing pot is also necessary, but is usually sold separately.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0017-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("TYPICAL BATCH OF HOMEBREWING INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("A basic kit of homebrewing ingredients contains dry or liquid malt extract, priming sugar, crushed grains, hops, and yeast, plus hop and grain bags and caps.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Follow the Extract Plus Steeped-Grain Procedure on "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev3"
    }
  }, [_vm._v("page 119")]), _vm._v(". The whole thing should take about 3 hours. Don’t forget to measure the original gravity and write everything down on a worksheet "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#page_241"
    }
  }, [_vm._v("(see page 241)")]), _vm._v(". When the wort, or unfermented beer, is cooled, add, or “pitch,” the yeast. Place the beer in a location with a fairly constant temperature of 58 to 70°F/14 to 21°C, away from bright light.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Watch your beer go through the stages of fermentation "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#page_218"
    }
  }, [_vm._v("(see Fermentation from Start to Finish, page 218)")]), _vm._v(". After a few days of vigorous activity, the foam will subside and the surface will clear. At this point the beer is in the conditioning phase, which should take 1 to 2 weeks. When the beer clears and appears to darken, it’s ready for bottling.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Follow the bottling directions on "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#page_226"
    }
  }, [_vm._v("page 226")]), _vm._v(". Store at the same temperature as fermentation, or possibly a little warmer if you want the beer to carbonate faster.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Give it a week or more to ferment, chill one, then open a bottle and taste the beer to check the carbonation. If the beer’s nicely sparkly, this will be one of the more exciting moments of your life. If it’s not, wait another week for your moment of ecstasy.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('span', {
    staticClass: "black"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Now you can get back to this book while you plan your next brew.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0017-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The late Bill Friday’s buttons summed up the spirit of the hobby. Photo by Ed Bronson.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev2"
    }
  }), _vm._v("ABOUT THIS BOOK")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("This handbook is intended to be a comprehensive guide to homebrewing with a special focus on how to understand, manipulate, and control the flavor of beer. The choice of ingredients, the way they are blended and processed at every step, the many variables of fermentation, and, finally, packaging, serving, and aging all have roles to play in what ends up in the glass. While there are almost always technical reasons behind the many decisions in brewing a beer, each choice nearly always has an artistic reason to consider as well—or should have if you’re doing it right.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Fortunately, beer is quite forgiving. If you pay attention to just a few things—first among them sanitization—you can easily make some delicious beer. Jump in, get some brews in the tanks, and become the big beer celebrity of your circle of friends; once you’re having a ton of fun with it, start pushing yourself to understand and manage all the technical aspects. Your beers will rise in quality as your ambitions do. It’s a fascinating and rewarding challenge, the perfect recipe for a great hobby.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("I have spent a career as a graphic designer and a writer, and I believe that beer is art, period. It lives in the sensory, emotional, and conceptual parts of our brains. Beer’s purpose is to tickle people, and there is no equation for that. No amount of brewing science can tell you "), _c('em', [_vm._v("what")]), _vm._v(" to brew. That takes imagination, creativity, and a well-developed sense for the flavors and aromas of both raw ingredients and the finished product—art, art, art!")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The road to creating art can feel a bit vague, partly because it’s a more internal process and for sure it can’t be reduced to numbers. But that doesn’t mean it’s all moonbeams and unicorns. There are some methodical, practical, and even scientific aspects to the art of brewing, and I’m going to lay those out for you in some detail.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("One of my main goals is to get you completely comfortable formulating your own recipes. The tools for calculation are here, but beyond that, I’ve tried to give you some ways to think about the structure of the recipes: from the top-down concept to the way ingredients are layered to do particular jobs to the roles of process and fermentation. With a little study, anyone should be able to conjure up a vision of their next beer, then create a recipe and work out the details so the finished brew nails the concept.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("On the technical side, I have tried to get the latest points of view on important controversial topics. For most hotly debated issues (like hot-side aeration, for instance), it turns out that good, general practice when you brew is enough to keep you out of trouble. Special brews or circumstances sometimes demand special procedures; but otherwise, it’s useful to remember that brewers before industrialization made beer good enough to be celebrated in poetry and song using little more than wooden tubs and sticks—along with keen senses and some well-honed experience.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hdnote"
  }, [_vm._v("Why Homebrew?")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_txt"
  }, [_c('em', [_vm._v("I’ve got my reasons to homebrew, but I thought it would be fun to pose this question to some of the best brewers and beer thinkers I know from around the world. They have answered this far better than I could have")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("To make beer is to make happiness")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("MARCO FALCONE,")]), _vm._v(" owner and brewmaster, Falke Bier, Belo Horizonte, Brazil")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Homebrewing is the often-invisible roots of the more visible tree of craft brewing. Homebrewers are among the most innovative breweries in America and there are millions of them. They can try crazy things in five-gallon batches")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("JIM KOCH,")]), _vm._v(" cofounder and chairman, the Boston Beer Company, Boston, MA")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("The grand pooh-bah of American homebrewing, Charlie Papazian, has a catchphrase: “Relax. Don’t worry. Have a homebrew.” And he’s right. Relaxing means broadening your focus and keeping in mind what the purpose of all the effort is. If you don’t have time to dig deeply into the pleasures of beer, to know them in a most intimate way, how will you ever know what beer is capable of and what science can do for you?")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("For me, this is the real compelling thing about brewing: it requires discipline and imagination in both the empirical and the lyrical spheres. Brewing offers rewards far beyond what ends up in your cup. It can push us places we wouldn’t go without it.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0019-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Members of the Tampa Bay BEERS homebrew club get happy at a recent American Homebrewers Association Conference. Photo by Edward Bronson.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Homebrewing is important for the same reason that home cooking is important. It is an act of creation that keeps us connected to our natures as creatures. After all, beer is liquid bread, a food, sustenance for both body and soul, which is probably why for most of civilization the person in charge of the domestic hearth tended to both the stew and the brew")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("SABINE WEYERMANN,")]), _vm._v(" Weyermann Malting, Bamberg, Germany")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev3"
    }
  }), _vm._v("WHAT’S IN HERE?")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("We start with a brief introduction to beer and the ways it is measured and described, including an overview of the human sensory apparatus as it relates to beer—becoming a good taster is a hugely important aspect of being a brewer. After that, you’ll find sections on ingredients, the brewing process through fermentation, and the equipment you’ll need to start your home brewery. Then we’ll dig into recipe formulation from a predictive and conceptual standpoint. The recipes start in "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_vm._v("chapter 7")]), _vm._v(". First is a whirlwind tour of beer styles with plenty of recipes, including the classic brewing traditions of Europe and the beers inspired by those traditions, like the new American beers. Next are some of the fascinating beers folks around the world are brewing with local flavors and creative approaches, followed by beers with alternate ingredients. Then comes a personal approach to a year of beer, season by season. I’ve devoted a chapter to problem solving and, finally, there is a guide to books, groups, and other resources to aid in your quest for the perfect beer.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("This work is peppered with pithy bits of wisdom from the world’s brewing elite. Some you have heard of, others maybe not; they offer this book a perspective you could never get from just me. Wherever possible, I have tried to present information visually to show the relationships that might be less gripping in paragraph form.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("My goal is to bring an interested novice quickly up to speed, so that he or she is able to produce varied and delicious brews right from the start. This book is also a practical tool, helping the brewer understand the ingredients, methods, and variables of the brewing process in order to make decisions that benefit the broth in your kettle.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Even if I could go to a Michelin three-star restaurant nightly, on occasion I would prefer to stay home and cook. Homebrewers enjoy brewing, and enjoy pleasing their friends with the fruits of their labors even more. Homebrewing is like making love; the simplest success is exciting")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("CHARLES FINKEL,")]), _vm._v(" founder, Merchant Du Vin Beer Importers, and co-owner, Pike Brewing Company, Seattle, WA")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "ch1lev4"
    }
  }), _vm._v("BREWING "), _c('span', {
    staticClass: "font"
  }, [_vm._v("with")]), _vm._v(" BOTH HALVES "), _c('span', {
    staticClass: "font"
  }, [_vm._v("of")]), _vm._v(" YOUR BRAIN")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Brewing, if you do it right, will use your whole brain. The range of technical details is vast, covering everything from metallurgy to biochemistry, which requires some informed and systematic thinking. Ingredient characteristics, beer styles, and recipes must be worked out with numbers. There is a good deal of engineering to it.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Beer is far more than numbers, though. Brewing well is about the impact it can have on the human psyche. It triggers memories, creates emotion, and tells stories. This is where art lives. Science has nothing to say about these subjects. It is just a tool of the artist to achieve a particular end.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Most of us, because of our inclinations, schooling, and career paths, are stuck in one cubbyhole or the other, but brewing offers us the opportunity to give the less-used hemisphere a workout. With brewing, artists can play mad scientist, engineers can dabble in the arts. Brewing makes us whole.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev5"
    }
  }), _vm._v("THINKING LIKE "), _c('span', {
    staticClass: "font"
  }, [_vm._v("a")]), _vm._v(" SCIENTIST")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The field of science has developed a framework of ideas, definitions, and relationships over the last few centuries to describe the world around us and how it functions. This system depends on specialized language as building blocks to an understanding of the nature of things. To non-scientists this language can seem arcane and daunting. But in order to dive in to the technical side of brewing and fermentation, it will be helpful to have a refresher course in some of the terms and concepts.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Physics, chemistry, and biology are all involved in the brewing process. Physics describes the mechanical, electrical, and other physical aspects of the universe. In brewing, heat transfer, gas behavior, liquid flow, and other phenomena fall in this category. Chemistry involves the interaction of molecules and their component atoms and ions, of which there are a bewildering variety in the brewing process. Biology is a mix of chemistry and physics applied to the specialized world of living things—in beer’s case, grain and yeast. Biochemistry is the unique chemistry of living organisms. It drives many of the important facets of brewing, from enzyme activity to fermentation.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("As a brewer, it’s your job to monitor and manipulate the physical and biochemical activity of brewing and get it to do your bidding—no more, no less. Science provides the framework that allows us to think empirically, using numbers to describe physical processes. This makes it possible to predict things like color and gravity in our recipes, and have some control over the brewing process. At the same time, it’s important to cultivate a sense of what’s meaningful and useful. Most brewing calculations focus on a few key variables and ignore a host of other parameters, so they’re only approximate. As you work with them over time, you get a feel for how accurate they can be and how to get the greatest benefit with the least amount of stressing out over insignificant details.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "ch1lev6"
    }
  }), _vm._v("WHAT "), _c('span', {
    staticClass: "font"
  }, [_vm._v("to")]), _vm._v(" WORRY ABOUT")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("As a new brewer, there are a thousand things you imagine can go wrong, turning all your hard work into a slimy disgusting mess, ruining your reputation, and poisoning the neighborhood in the process. Relax. You won’t poison anybody; pathogens can’t live in beer. The chances of a flavor disaster are slim, too. Most likely, you will make tasty beer right from the start. Making it better will be a long march of incremental changes. Every added piece of knowledge put into practice will make your beer a little bit better.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("If there’s one thing to be obsessive about, it’s cleaning and sanitization—well, okay, that’s two things—because dirty equipment and sloppy sanitization will ruin a beer in many creatively horrifying ways. It’s best to develop good habits about cleanliness in the brewery, and get good, brewery-grade cleaning and sanitizing chemicals. It’s also important to follow manufacturer’s recommendations on the dilution and use of these chemicals to ensure they work right and don’t have harmful effects on the beer.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mad Zymurgists Club booth at a Homebrewing Conference. Science is something you take very seriously—or you don’t.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Homebrewing is a good school")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("YVAN DE BAETS,")]), _vm._v(" brewmaster and founder, Brasserie de la Senne, Sint-Pieters-Leeuw, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("Precision is a subject of endless debate in the homebrewing community, and it’s easy to understand why. Small things can add up to better beer to drink. When confronted with numbers, as we often are in brewing, it is easy to focus on them and lose sight of their true meaning, which is how they relate to what’s in the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Chasing a certain mash pH or predicting hop bitterness to the second decimal place can be fun, but we are not trying to launch a spacecraft into orbit around Saturn. Hop bitterness, for example, can be reliably predicted only within about 10 percent, perhaps less. This seems pretty rough, but it turns out that we can distinguish bitterness only in 5 BU (Bitterness Units, sometimes called IBU or International Bitterness Units), and this is for bitterness below about 20 BU; it gets worse at higher numbers. So, 10 percent accuracy in your hop predictions turns out to be plenty good enough. The same tolerance of imprecision applies to color calculations, and for most people, alcohol percentage as well.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Yeast likes ideal conditions, but it’s hardy and adaptable and will produce perfectly fine beer even if things are a wee bit off. So if you’re inclined to get carried away with the technical details, make sure one of them is the notion of scale, and check to make sure you’re not just pursuing numbers for numbers’ sake.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Fine-tuning certain specifics can have great effect in some circumstances. The question is, which specifics? For the answer, I refer you to Mr. Ray Daniels, quoted at right. The range of options in brewing is so vast that it’s almost impossible to master or control every one. Futile, too, because a packaging lager brewery, a monastery in Belgium, a real-ale-focused craft brewery, and the guy in his garage with the amazing setup (you, eventually) all need different things—or rather the beer does.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("For brewery predictions, repeatability is perhaps the better goal to focus on. Because unless you buy some expensive laboratory equipment, you probably never will know what color or hop bitterness you’re getting. Absolute precision is kind of a false idol unless you’re a nut for analysis. As a product for the senses, beer has to meet the expectations of sight, smell, and taste—machines be damned. We’re all flawed, with limited resolution and accuracy, so a rough calculation is all we really need.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("I’m a scientist and engineer by training but I submit to the world of faith and the unknowable. One should be disciplined yet open to simple experiences. Still the brewing process follows the laws of nature, so we must embrace the clarity of science while appreciating the chaos. What can we create? What happens when we make subtle changes in process or material? That’s the marriage of art and science")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("DAN CAREY,")]), _vm._v(" cofounder and brewmaster, New Glarus Brewing Company, New Glarus, WI")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("The answer to any technical brewing question is “It depends.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("RAY DANIELS,")]), _vm._v(" founder and CEO, Cicerone Certification Program, and author of "), _c('em', [_vm._v("Designing Great Beers")])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev7"
    }
  }), _vm._v("CHEMICAL "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" BIOCHEMICAL CONCEPTS")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("A full understanding of the complexities of brewing requires some familiarity with the various players and processes. The following list of terms may seem like highly technical jargon, but specialized language is required to describe the highly specific concepts involved in beer brewing.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev1"
    }
  }), _vm._v("pH")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is a measure of the acidity or alkalinity of a substance. The "), _c('em', [_vm._v("H")]), _vm._v(" refers to hydrogen ions, which are actually protons that carry a positive electrical charge. The more hydrogen ions, the more acidity; the more they are lacking (an excess of electrons), the more alkaline, or basic. It’s a logarithmic scale; each full step represents a tenfold increase over the last. Neutral pH is at 7, indicating neither an excess nor dearth of hydrogen ions and electrons. Above 7 becomes more alkaline, and below, more acidic.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("pH SCALE")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "BATTERY ACID LEMON JUICE WINE PURE WATER BAKING SODA HOUSEHOLD BLEACH OVEN CLEANER ACIDIC NEUTRAL BASIC 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 3 4 5 6 SOUR BEER (3.1–3.7) BEER (3.7–4.1) WORT (5.0–5.6) MASH (5.2–5.8) Boiling drops pH 0.1–0.2 units",
      "src": "images/f0023-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("A pH scale is helpful in measuring the acidity or alkalinity of your beer, wort, or mash.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev2"
    }
  }), _vm._v("MOLECULE")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('strong', [_vm._v("Two or more atoms held together in a stable configuration through chemistry.")])]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg24lev1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("ION")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("An electrically charged atom or group of atoms. It is useful to think of brewing water ions such as carbonate or calcium as half-molecules, because when mineral salts dissolve in water they come apart, or dissociate into their individual ions, which are attracted to other ions in the solvent according to their electrical charges. These dissociated ions can be manipulated in various ways to achieve the desired water chemistry for a specific brew.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("IONS IN AND OUT OF SOLUTION")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Sodium chloride (NaCl) in solid state Water (H2O) molecule Chlorine (-) attracted to positive end of water molecules Sodium (+) attracted to positive end of water molecules",
      "src": "images/f0024-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("Mineral salts dissociate into their individual ions when they dissolve in brewing water that can then be manipulated in various ways to achieve the desired water chemistry for a specific brew.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg24lev2"
    }
  }), _vm._v("BUFFERING")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("The ability of certain molecules to soak up acids or bases even if they are not themselves strongly basic or acidic. This is an important aspect of mash chemistry, as a number of chemicals in that process have strong buffering capabilities.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg24lev3"
    }
  }), _vm._v("REACTION")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("In order for matter to be transformed from one chemical state to the other, it must undergo a reaction. At the beginning, each molecule has a particular energy state, and the reaction will turn the reactants into different chemicals with a higher or lower energy level. But in order to do so, the reaction has to have energy put into the system. You can think of this energy as a hill: On one side is before the reaction, and the other side is after. In order to get to the other side, a push is needed up the hill so it can roll down the other side. Some reactions, like the splitting of starch molecules into sugar in the mash, may require a good deal of energy input to make the transformation.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg24lev4"
    }
  }), _vm._v("ENZYME")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A specialized type of protein molecule that can act as a catalyst, which is a substance that aids in chemical reactions by lowering the energy barrier, and thus the amount of energy needed to make the reaction happen. Enzymes seem miraculous, often lowering the required energy by a factor of a millionfold or more. There are hundreds of them involved in brewing and yeast physiology. Life would be quite impossible without them.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_indent"
  }, [_vm._v("Every enzyme has temperature, pH, water concentration, and other parameters that determine its level of activity. Enzymes are named for the chemicals they act upon, and generally end in "), _c('em', [_vm._v("ase")]), _vm._v(". Amylase is the type of enzyme that breaks apart the barley starches known as amylose and amylopectin, hence the name, meaning “starch-attacking enzyme.”")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg24lev5"
    }
  }), _vm._v("POLYMER")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A type of organic molecule formed by combining smaller subunits. They are ubiquitous in living things. We will be most interested in two types: proteins and starches.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "pg25lev1"
    }
  }), _vm._v("CARBOHYDRATES")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("This is a large class of compounds built from five- or six-sided ring-shaped molecules. The simplest forms in this large class of compounds are monosaccharide sugars such as glucose (dextrose) and fructose. Two sugar units attached to one another become a disaccharide; in brewing, this is mostly maltose. Somewhat longer chains are known as oligosaccharides or dextrins, and when the chain becomes longer than about ten units, it is known as starch.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_hd"
  }, [_c('strong', [_vm._v("SOME SUGARS AND OTHER COMMON CARBOHYDRATES IN BREWING")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-01.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("GLUCOSE/DEXTROSE")]), _c('br'), _vm._v("Simple sugar released during malting. Less than 10% of extract. Also sometimes used as an adjunct.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-02.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("MALTOSE")]), _c('br'), _vm._v("A two-unit sugar, the main fermentable in wort, created during mashing. Less than 10% of extract.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-03.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("MALTOTRIOSE")]), _c('br'), _vm._v("A three-unit sugar, a minor wort component. Fermentable by lager yeast but not ale yeast.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-04.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("MALTOTETRAOSE")]), _c('br'), _vm._v("A four-unit sugar unfermentable by any brewers’yeast.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-05.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("DEXTRINS")]), _c('br'), _vm._v("Longer sugars (up to 10 units), unfermentable by any brewers’ yeast. Depending on brewing process, varying amounts can end up in beer.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-06.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first1_indent"
  }, [_c('strong', [_vm._v("STARCH")]), _c('br'), _vm._v("Longer straight-chain (amylose) or branched (amylopectin) carbohydrates. Generally, beer contains no starch.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("The sugars and carbohydrates involved in brewing vary in complexity and structure.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg25lev2"
    }
  }), _vm._v("AMINO ACID")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A class of nitrogen-bearing molecules that are the building blocks of proteins. There are just twenty of them in most living things. We will not be concerned much about specific ones, but as a group, they are a critical aspect of yeast nutrition derived from malt.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg25lev3"
    }
  }), _vm._v("PROTEIN")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A specialized class of polymeric molecules composed of amino acids. They play many different roles in living things, from structural roles as sheets and tubes to highly complex and chemically active molecules that serve as enzymes, signaling chemicals, and more. Proteins are so much a part of life that they are what our DNA encodes for—literally, what we’re made of.")]), _vm._v(" "), _c('h5', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "pg25lev4"
    }
  }), _vm._v("POLYPEPTIDE")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("A chain of amino acids not large enough to be a protein, but that connect to form proteins.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-07.jpg"
    }
  })])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev8"
    }
  }), _vm._v("BREWING LIKE "), _c('span', {
    staticClass: "font"
  }, [_vm._v("an")]), _vm._v(" ARTIST")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Ultimately, beer has to interact with the senses and the mind, which are mostly beyond our ability to quantify. Making delicious, interesting, and resonant beers requires a good deal of self-awareness as well as a keen perception of the way others experience the world.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("In my view, art is all about messing with people’s heads. At the highest level, this is what brewing is about—our ability to get in there and affect people. It’s a huge power and a privilege, ultimately quite an intimate act. We are plucking the sensory notes and emotional associations people have built up over a lifetime of happy moments—candy, bread, cake, cookies, chocolate, raisins, citrus, grass, pine trees, sagebrush, fruit—and we’re just waiting for the beer to pour in and push those buttons.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("To do this in brewing, as with any art, requires an intuitive grasp of the qualities of the raw materials and the way they interact and transform into the finished product. It’s important to be able to focus on the sensations offered by beer and its ingredients, and build up an internal library of qualities and impressions about them. This is something you never stop learning. Try walking around your neighborhood just paying attention to the smells. It’s an amazing experience. Do the same with malts and hops every time you have the chance.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("It’s important to know your drinkers as well. As a homebrewer, your beer usually stays close to home, so there’s not a lot to think about. But when you take it to a different audience, you have to do a little research. I love to brew beer for weddings and other celebrations because it forces me to think about the beer in fresh terms, from the point of view of a new audience. This is as fun as it is challenging. Those of you who are interested in competitive brewing will have to consider the judges, who have a very particular point of view thrust on top of their personal likes and dislikes. It is helpful to see the beer through their eyes, which is one of the reasons it’s so useful to become a judge yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Art is not entirely intuitive. There are rules, or rather tools, like contrast, layering, hierarchy, counterpoint, and others, that give artists many different ways to construct and organize their work. If you have experience with any other art form, you will recognize these immediately. I’ll have plenty more to say about these in "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_vm._v("chapter 7")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('em', [_vm._v("Brewing has encouraged me to seek out a social network of like-minded curious, generous, passionate, and kind people, and it has re-ignited my desire to learn more about history, alchemy, biology, and chemistry. I now seek out others’ opinions about the challenges it poses. In short, I believe brewing has made me a better, more rounded (figuratively as well as literally) person")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("CHRIS P. FREY")]), _vm._v(" chairman, American Homebrewers Association governing committee")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1lev9"
    }
  }), _vm._v("GETTING STARTED "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" GETTING BETTER")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("A top goal of a new homebrewer is to get set up and get brewing really tasty beers as soon as possible, and this is a realistic goal. We are lucky to have so many different ways to make beer, from super simple to crazy complicated. With the right equipment and skills, an advanced brewer can control every tiny detail of the brewing process and create beers on a par with any in the world. Beginners give up a bit of control and accept limitations in exchange for speed and simplicity. The typical pattern is to get comfortable with the basics, then as confidence and resources allow, move to more complicated brewing procedures that allow them to use the same full range of ingredients and techniques as professional brewers.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Most homebrewers start brewing with an extract method incorporating steeped grains, like the one at the beginning of "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4"
    }
  }, [_vm._v("chapter 4")]), _vm._v(". It’s an easy method that takes just 2 to 3 hours, and requires minimal equipment and space. Typically, you’ll boil only 3 gallons/11 L, and this is mixed with sanitized water in the fermenter. For these reasons, many people will stick to this procedure for making beer and never feel the need to make brewing any more complicated.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("This method does have its limitations. Without mashing—the cooking procedure that breaks down malt starches into sugars—the brewer is relying heavily on the malt manufacturer and is limited to crushed grains like caramel malt that yield extract without a proper mash. Not all beer types can be brewed using this procedure.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The next step up incorporates a mini mash of specialty grain, giving you many more choices in the recipe. This process uses the same time and temperature profile—usually an hour at 150°F/66°C—as a full-scale brew, but the mash is limited to a portion of the recipe, and malt extract forms the majority of the base, which adds about an hour to the brew session but allows you to use nearly any kind of specialty malts for a far larger range of possible beers. This method requires a small, insulated container with some sort of false bottom or screen to separate the liquid from the solids when done. As in the extract-plus-steeped-grain method, the full volume of the wort need not be boiled.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0027-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Me and my original brewing partner, Ray Spangler, bottling batch number two, c. 1985. Photo by Nancy Cline.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("The biggest step up is to go to full grain. This gives you the same control over your recipe and process as the largest commercial breweries and allows you to make totally authentic versions of any beer style on Earth. The drawback is a little more equipment, including a kettle capable of boiling the full volume of the brew and a mash tun that is typically twice the volume of the brew. Setups for mashing range from super simple to rocket-science complicated. For many of us, making equipment is every bit as fun as brewing. However, simple equipment with a skilled brewer will make beer just as good as the most elaborate and costly system. The other investment you have to consider is time. A typical 5-gallon/19-L batch of full-mashed beer will take between 4 and 6 hours; larger batches take a little longer.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("These three methods typically represent a progression as a brewer gains more confidence and is corrupted by this seductive and soul-stealing hobby. A brewer might start with extract and a little caramel malt, switch to mini mashes, then after a year or so, move to full mashes. Some people start mashing right away; others are perfectly happy using extract and some specialty grains. It’s a matter of personal choice, but you don’t have to decide right away. Most of the recipes in this book can be brewed with either an all-grain mash or an extract method.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_2_hd"
  }, [_vm._v("Extract Brewing Overview")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "1 About 3.5 gl/13 L water 1–2 lb/0.5–1 kg crushed grains HEAT ALMOST TO BOILING 2 About 3 gl/11 L REMOVE AND DRAIN GRAIN BAG 3 ADD MALT EXTRACT About 3.5 gl/13 L STIR WELL TO DISSOLVE 4 ADD HOPS 60 minutes for bitterness 5 minutes from end for aroma About 3.5 gl/13 L BOIL 60 MINUTES CHILL AND DRAIN WORT 5 6.5 gl/25 L carboy About 3 gl/11 L ADD STERILE (BOILED) WATER TO MAKE 5.5 gl/21 L 5.5 gl/21 L ADD YEAST",
      "src": "images/f0028-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_vm._v("The extract + steeped grains procedure is a simple 2- to 3-hour extract method that requires minimal equipment and space.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("I highly recommend hooking up with a homebrewing club in your area. There are hundreds of them around the world, and places without a thriving club are increasingly rare. Even if you’re not normally a joining kind of person, try to make contact anyway. Homebrew clubs are among the friendliest, most supportive, and enjoyable communities on the planet; an invaluable source of advice as well as camaraderie. Being connected to a club will definitely improve your beer and your brewing experience.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Entering competitions and judging them will also improve your brewing. Even if you’re not a competitive person, every beer you enter receives a detailed judging form filled out by two or three judges, providing valuable feedback that is well worth the cost of entry. The narrow strictures of brewing to style, even if you chafe at them, are a real test of your ability to control the process for a specific result. Becoming a judge gives you insight into beer’s flavors and styles that is nearly impossible to achieve any other way.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Be sure you maintain a fun, positive, and relaxed attitude about this hobby. It’s easy to become obsessed with the many technical aspects of brewing, and if you let them, they can turn brewing into a frustrating chore. No matter what, keep the big picture in mind. Beer is about pleasure, sharing, and fun. Watching someone taste your beer and break into a wide smile is one of life’s great, soul-satisfying joys.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hdnote"
  }, [_vm._v("Ready to start brewing right now?")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_txt"
  }, [_c('em', [_vm._v("Turn to "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#page_116"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("page 116")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ee67c32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08-chapter01.vue
// module id = 78
// module chunks = 0